export const DirectorStory = ({ story }) => story ? <details className="sw-director-story" data-testid="director-story">
  <summary data-testid="director-story-toggle">Read the story the writer created first</summary>
  <div className="sw-director-story-text" data-testid="director-story-text">{story}</div>
</details> : null;
